import { generatePath } from 'react-router-dom';

import { DATA_UPLOAD_METHOD } from 'constants/common';
import { UPLOAD_FILE_PATH, IMPORT_DATA_PATH } from 'constants/paths';
import { DATA_IMPORT_STEP, REPORT_STEPS_MAPPING } from 'constants/report-steps';
import { Report } from 'graphql-api';

const dataImportMethodPath = (dataImportMethod: string | null | undefined): string => {
  if (dataImportMethod === DATA_UPLOAD_METHOD) {
    return UPLOAD_FILE_PATH;
  } else {
    return IMPORT_DATA_PATH;
  }
};

export const reportCurrentStepPath = (report: Report): string => {
  const currentPath =
    REPORT_STEPS_MAPPING[report.currentStep ?? DATA_IMPORT_STEP] ?? IMPORT_DATA_PATH;
  const navigatePath =
    currentPath === IMPORT_DATA_PATH ? dataImportMethodPath(report.dataImportMethod) : currentPath;
  return generatePath(navigatePath, { reportSlug: report.slug });
};
